import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { InteractiveCasesService, InteractiveCase } from '../../services/interactive-cases.service';

@Component({
  selector: 'app-interactive-cases',
  templateUrl: './interactive-cases.component.html',
  styleUrls: ['./interactive-cases.component.scss']
})
export class InteractiveCasesComponent implements OnInit {
  @Output() navigate = new EventEmitter<{section: string, title: string, data?: any}>();
  
  cases: InteractiveCase[] = [];
  loading = true;
  sortColumn: string = 'caseNo';
  sortDirection: 'asc' | 'desc' = 'asc';

  constructor(
    private interactiveCasesService: InteractiveCasesService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.loadCases();
  }

  loadCases(): void {
    this.loading = true;
    this.interactiveCasesService.getInteractiveCases().subscribe(
      (cases) => {
        this.cases = cases;
        this.sortData(this.sortColumn, this.sortDirection);
        this.loading = false;
      },
      (error) => {
        console.error('Error loading interactive cases', error);
        this.loading = false;
      }
    );
  }

  sortData(column: string, direction: 'asc' | 'desc' = 'asc'): void {
    this.sortColumn = column;
    this.sortDirection = direction;

    this.cases.sort((a: any, b: any) => {
      const valueA = a[column];
      const valueB = b[column];
      
      if (typeof valueA === 'number' && typeof valueB === 'number') {
        return (direction === 'asc') ? valueA - valueB : valueB - valueA;
      } else {
        const comparison = String(valueA).localeCompare(String(valueB));
        return (direction === 'asc') ? comparison : -comparison;
      }
    });
  }

  toggleSort(column: string): void {
    if (this.sortColumn === column) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumn = column;
      this.sortDirection = 'asc';
    }
    this.sortData(this.sortColumn, this.sortDirection);
  }

  getSortIcon(column: string): string {
    if (this.sortColumn !== column) {
      return 'pi-sort'; // Neutral sort icon
    }
    return this.sortDirection === 'asc' ? 'pi-sort-up' : 'pi-sort-down';
  }

  launchCase(caseId: number): void {
    console.log(`Launching case with ID: ${caseId}`);
    // Navigate to launch-case route with the case ID as a parameter
    this.router.navigate(['/launch-case', caseId]);
  }

  getExplanation(caseId: number): void {
    // Find the case to get its details
    const caseItem = this.cases.find(c => c.id === caseId);
    const title = caseItem ? `Case #${caseItem.caseNo} Explanation` : 'Case Explanation';
    
    // Send navigation event up to the parent component
    this.navigate.emit({
      section: 'case-explanation',
      title: title,
      data: { explanationCaseId: caseId }
    });
  }
} 